import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

/* Add Policy Category Service*/
const createPolicyCategory = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.createPolicyCategory}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Get All Policy Categorys Service*/
const getAllPolicyCategorys = (params) => {
    const { axiosInstance, config,  } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.getAllPolicyCategorys}`,
        method: "GET",
        headers: config.headers || null,
        params: params,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/*  Update Policy Category Service*/
const updatePolicyCategory = (params) => {
    const { axiosInstance, config, source } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.updatePolicyCategory}`,
        method: "PUT",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};



/* Delete Policy Category Service*/
const deletePolicyCategory = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.deletePolicyCategory}`,
        method: "DELETE",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};


/* Create Policy  Service*/
const createPolicy = (params) => {
    const dataParam = {
        type: 'upload', 
    };
    const { axiosInstance, config } = getAxiosConfig(dataParam);
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.createPolicy}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Get All Policy Service*/
const getAllPolicy = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.getAllPolicy}`,
        method: "GET",
        headers: config.headers || null,
        params:params,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};


/* Get Policy By Category Id*/
const getPolicyByCategoryId = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.getPolicyByCategoryId}`,
        method: "GET",
        params:params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Update Policy*/
const updatePolicy = (params) => {
    const dataParam = {
        type: 'upload',
    };
    const { axiosInstance, config } = getAxiosConfig(dataParam);
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.updatePolicy}`,
        method: "PUT",
        data:params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Delete PolicyService*/
const deletePolicy = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.deletePolicy}`,
        method: "DELETE",
        data:params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};



/* Accept Policy By User Service*/
const acceptPolicyByUser = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.acceptPolicyByUser}`,
        method: "POST",
        data:params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};


/* Get Policy Category List Service*/
const getPolicyCategoryList = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.getPolicyCategoryList}`,
        method: "GET",
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};


/* Get Policy List Service*/
const getPolicyList = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.getPolicyList}`,
        method: "GET",
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Get Policy List Service*/
const getClientTermsAndConditions = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.getClientTermsAndConditions}`,
        method: "GET",
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};


/* Get Client Terms And Conditions Service*/
const sendOtpVerification = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.sendOtpVerification}`,
        method: "POST",
        headers: config.headers || null,
        mode: "no-cors",
        data:params,
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};


/* Verify Client Terms OTP Service */
const verifyClientTermsOTP = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.verifyClientTermsOTP}`,
        method: "POST",
        headers: config.headers || null,
        mode: "no-cors",
        data:params,
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};


/* Accept And Reject Client Terms Service */
const acceptAndRejectClientTerms = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.acceptAndRejectClientTerms}`,
        method: "POST",
        headers: config.headers || null,
        mode: "no-cors",
        data:params,
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

export default {
    createPolicyCategory,
    getAllPolicyCategorys,
    updatePolicyCategory,
    deletePolicyCategory,
    createPolicy,
    getAllPolicy,
    getPolicyByCategoryId,
    updatePolicy,
    deletePolicy,
    acceptPolicyByUser,
    getPolicyCategoryList,
    getPolicyList,
    getClientTermsAndConditions,
    sendOtpVerification,
    verifyClientTermsOTP,
    acceptAndRejectClientTerms
}